// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const LockClosedIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M4 10a8 8 0 1116 0H4zm14 0a6 6 0 10-12 0h12zm-5.016 6.741a2 2 0 10-1.992-.013L10 19h3.978zM4 10h16v10a2 2 0 01-2 2H6a2 2 0 01-2-2z" fill="currentColor"/></svg>'} />;

LockClosedIcon.displayName = 'LockClosedIcon';

export default LockClosedIcon;
